import axiosClient from "utils/api";
const URI = "/admin/userFeedback";

export const getFeedback = async (payload) => {
  const { type, ...rest } = payload;
  const URL = `${URI}/${type}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
      params: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred during get feedback:", error);
    throw error;
  }
};

export const updateFeedbackStatus = async (payload) => {
  let { id, ...rest } = payload;
  const URL = `${URI}/${id}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "put",
      data: rest,
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Update feedback:", error);
    throw error;
  }
};
